// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3Mlkw","containerItemsCenter":"Skeleton_containerItemsCenter__2fqd3"};